/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import QuestionFormat from 'pages/dashboard/embeds/management/customize/pageproperties/questionproperties/questionformat/questionformat_container';
import Title from 'material/copy/title/title';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/pageproperties/questionproperties/questionproperties_styles';


/* ========== ~~~~~~~~~~ QUESTION PROPERTIES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const QuestionProperties = (props) => {

    const displayFormatOptionsBasedOnContentType = () => {
        switch (props.contentType) {
            case 'poll':
                return [<QuestionFormat key={'emoji'} type={`emoji`} desc={`Emoji`} />];
            default:
                return null;
        }
    }
    const showPlacement = () => props.location === 'in-content' ? 'incontent' : 'rail';

    return (
        <div className={`questionproperties ${props.classes.questionproperties} ${showPlacement()}`}>
            <div className={"questioncontainer"} >
                <Title>
                    <h4>Question Style:</h4>
                </Title>
                <div className={`questionformatselector`}>
                    {/* below are common across questions */}
                    <QuestionFormat key={'image1'} type={`image1`} desc={`Round`} />
                    <QuestionFormat key={'image2'} type={`image2`} desc={`Large`} />
                    <QuestionFormat key={'text1'} type={`text1`} desc={`Text`} />
                    <QuestionFormat key={'text2'} type={`text2`} desc={`Text`} />
                    {/* content type specific */}
                    {displayFormatOptionsBasedOnContentType()}
                </div>
            </div>
        </div>
    );
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(QuestionProperties);